import clsx from 'clsx';
import { formatIQD } from '../../../shared/format.js';

export function PackageCard({ icon = '🎟️', name, price, sub, selected, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'text-right p-3.5 rounded-[14px] cursor-pointer transition-all',
        selected ? 'ring-2 ring-orange bg-orange-soft/40' : 'border border-line bg-white'
      )}
      style={selected ? { borderColor: '#FF7A1A' } : undefined}
    >
      <div className="text-[24px] mb-1">{icon}</div>
      <div className="font-bold text-[14px]">{name}</div>
      <div className="text-orange-deep font-bold text-[17px] my-1">
        {typeof price === 'number' ? formatIQD(price) : price}
      </div>
      {sub ? <div className="text-ink-3 text-[11.5px]">{sub}</div> : null}
    </button>
  );
}
